import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen, FaExclamationCircle, FaBars, FaCheckCircle, FaTimesCircle, FaSearch } from "react-icons/fa";
import * as FaIcons from 'react-icons/fa';
import * as MenuService from "../../../Services/Masters/Menu/MenuService";
import toast from "react-hot-toast";
import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import SubMenuComponent from "./SubMenuComponent";
import MultiSelect from 'multiselect-react-dropdown';
import CommonPagination from "../../../Common/CommonPagination";

const MenuComponent = () => {
  const [menuList, setMenuList] = useState([]);
  const [allMenuList, setAllMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState({});
  const [newMenuModal, setNewMenuModal] = useState(false);
  const [roleList, setRoleList] = useState([]);
  // const [editRoleMappingModal, setEditRoleMappingModal] = useState(false);
  const [editSubMenuModal, setEditSubMenuModal] = useState(false);
  const [currentMenuId, setCurrentMenuId] = useState(null);
  const [changeInMapping, setChangeInMapping] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const selectedSearchMenu = useRef();
  const [searchTerm, setSearchTerm] = useState('');

  // Pagination Code
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  const indexOfLastMenu = currentPage * itemsPerPage;
  const indexOfFirstMenu = indexOfLastMenu - itemsPerPage;
  const currentMenuList = menuList.slice(indexOfFirstMenu, indexOfLastMenu);

  const { register, handleSubmit, formState: { errors }, reset, watch } = useForm({
    defaultValues: {
      Is_Parent: selectedMenu?.Is_Parent || false
    },
  });

  const isParent = watch("Is_Parent");

  const fetchAllMenuMasterList = () => {
    MenuService.GetMenuList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setMenuList(data.Data);
          setAllMenuList(data.Data);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  };

  useEffect(() => {
    fetchAllMenuMasterList();
  }, []);

  const onSubmit = (data) => {
    //debugger;
    if (selectedMenu?.Menu_Id) {
      data.Menu_Id = selectedMenu?.Menu_Id;
      data.Sequence_No = data.Sequence_No === "" ? null : Number(data.Sequence_No);

      const formattedData = {
        "MenuMappingDet": roleList,
        "MenuMasterDet": data
      }

      MenuService.UpdateMenu(formattedData)
        .then(({ data }) => {
          if (data.IsSuccess) {
            fetchAllMenuMasterList();
            toast.success("Menu updated successfully!");
            handleNewMenuModalClose();
          } else {
            toast.error("Something went wrong during update.");
          }
        })
        .catch(() => toast.error("Something went wrong during update."))
        .finally(() => { });
    } else {
      data.Sequence_No = data.Sequence_No === "" ? null : Number(data.Sequence_No);

      const formattedData = {
        "MenuMappingDet": roleList,
        "MenuMasterDet": data
      }

      MenuService.CreateNewMenu(formattedData)
        .then(({ data }) => {
          if (data.IsSuccess) {
            fetchAllMenuMasterList();
            toast.success("Menu saved successfully!");
            handleNewMenuModalClose();
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong during creation."))
        .finally(() => { });
    }
  };

  const handleNewMenuModalClose = (type = "") => {
    //debugger;
    if (type === 'close') {
      if (changeInMapping === false) {
        setRoleList([]);
        setCurrentMenuId(null);
        // setEditRoleMappingModal(false);
      }
      else {
        toast.error("Please save the mapping changes first");
      }
    }
    else if (type === 'cancel') {
      setRoleList([]);
      setCurrentMenuId(null);
      // setEditRoleMappingModal(false);
      if (changeInMapping === true) {
        toast.error("Mapping change not saved");
      }
      setChangeInMapping(false);
    }
    else {
      reset();
      setSelectedMenu([]);
      setNewMenuModal(false)
      setRoleList([]);
      setCurrentMenuId(null);
      // setEditRoleMappingModal(false);
      setChangeInMapping(false);
    }

  };

  const handleActivateDeActivateMenu = (rec) => {
    MenuService.ActivateDeActivateMenu(rec.Menu_Id, !rec.IsActive).then(data => {
      if (data.data.IsSuccess) {
        const message = rec.IsActive ? "Menu DeActivated Successfully" : "Menu Activated Successfully";
        toast.success(message);
        fetchAllMenuMasterList();
      } else {
        toast.error("Somthing went wrong");
      }
    }).catch(error => {
      toast.error("Somthing went wrong");
    })
  }

  const handleViewMenuDetailById = (rec) => {
    //debugger;
    const selectedItem = menuList.find(item => item.Menu_Id === rec.Menu_Id);
    if (selectedItem != null) {
      setSelectedMenu(selectedItem);
      setCurrentMenuId(selectedItem.Menu_Id);
      getMappedUnMappedMenu_RoleList(selectedItem.Menu_Id)
      setNewMenuModal(true);
    }
    else {
      selectedMenu({});
    }
  };

  const handleMappingDelete = (Role_Id) => {
    //debugger;
    //setChangeInMapping(true)
    const updatedList = roleList.map(item =>
      item.Role_Id === Role_Id
        ? { ...item, IsDeleted: true, IsSelected: false, Menu_Id: currentMenuId }
        : item
    );
    setRoleList(updatedList);
  }

  const handleMappingInsert = (Role_Id) => {
    //debugger;
    //setChangeInMapping(true)
    const updatedList = roleList.map(item =>
      item.Role_Id === Role_Id
        ? { ...item, IsSelected: true, IsDeleted: false, Menu_Id: currentMenuId }
        : item
    );
    setRoleList(updatedList);
  }

  const getMappedUnMappedMenu_RoleList = (Id) => {
    MenuService.GetMappedUnMappedMenu_RoleList(Id)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setRoleList(data.Data);
          //console.log(data.Data)
        }
      });
  }

  const handleViewSubMenuList = (rec) => {
    setSelectedMenu(rec);
    setEditSubMenuModal(true);
  }

  const handleSubMenuModalClose = () => {
    reset();
    setEditSubMenuModal(false);
  }

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    setCurrentPage(1); // Reset to first page when searching

    if (!searchValue.trim()) {
      // If search is empty, show all partners
      setMenuList(allMenuList);
      return;
    }

    const filtered = allMenuList.filter(menus => {
      const searchLower = searchValue.toLowerCase();

      return (
        menus.Menu_Name?.toLowerCase().includes(searchLower) ||
        // menus.Description?.toLowerCase().includes(searchLower) ||
        menus.Url?.toLowerCase().includes(searchLower)
      );
    });

    setMenuList(filtered);
  };

  return (
    <>
      {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
      <CommonContainer icon={<FaIcons.FaListAlt size={20}/>} heading="Menu List" buttonText="Add Menu" onButtonClick={() => { reset(); setSelectedMenu([]); setNewMenuModal(true); getMappedUnMappedMenu_RoleList(0) }}>

        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
          </div>
          <div className="search-box" style={{ position: "relative", width: "320px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Menu Name, Url"
              ref={selectedSearchMenu}
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            />
            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)",
              }}
              // onClick={fetchUniversalFilterPartnerData}
              onClick={() => handleSearch(searchTerm)}
            >
              <FaSearch />
            </button>

          </div>

        </div>
        <div>
          <div className="table-responsive" >
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{width: "13%"}}> Menu</th>
                  <th style={{width: "15%"}}> Description</th>
                  <th style={{width: "15%"}}> Url </th>
                  <th style={{width: "10%"}}> Sequence_No </th>
                  <th style={{width: "15%"}}> Icon</th>
                  <th style={{width: "7%"}}> Is Parent </th>
                  <th style={{width: "7%"}}> Active </th>
                  <th style={{width: "7%"}}> Is Copy </th>
                  <th style={{width: "7%"}}> Is OTP </th>
                  <th style={{width: "5%"}}> Action </th>
                </tr>
              </thead>
              <tbody>
                {
                  currentMenuList.length > 0 ? (
                    currentMenuList.map((rec, index) => (
                      <tr key={index} >
                        <td>{rec.Menu_Name}</td >
                        <td>{rec.Description}</td >
                        <td>{rec.Url}</td >
                        <td>{rec.Sequence_No}</td >
                        <td>{rec.Icon}</td >
                        <td>
                          {rec.Is_Parent ? <FaCheckCircle color="green" size={16} /> : <FaTimesCircle color="red" />}
                        </td>
                        <td>
                          {rec.IsActive ? <FaToggleOn title="Deactivate Menu" onClick={() => handleActivateDeActivateMenu(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateMenu(rec)} title="Activate Menu" color="red" size={16} />}
                        </td>
                        <td>
                          {rec.Is_Copy_Disabled ? <FaToggleOn title="Deactivate Copy" color="green" size={16} /> : <FaToggleOff title="Activate Copy" color="red" size={16} />}
                        </td>
                        <td>
                          {rec.Is_Otp ? <FaToggleOn title="Deactivate Menu OTP" color="green" size={16} /> : <FaToggleOff title="Activate Menu OTP" color="red" size={16} />}
                        </td>
                        <td>
                          <div className="d-flex px-1 gap-2 align-items-center justify-content-center">
                            <FaPen color="green" style={{cursor: "pointer"}} onClick={() => handleViewMenuDetailById(rec)} title="Edit Menu" />
                            {/* <FaBars className="mr-2 cursor-pointer" color={"green"} onClick={() => handleViewSubMenuList(rec)} title="Edit Sub Menu Config"/> */}
                            <FaBars
                              style={{cursor: "pointer"}}
                              // className={`${rec.Is_Parent ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}`}
                              color={rec.Is_Parent ? "green" : "gray"}
                              onClick={rec.Is_Parent ? () => handleViewSubMenuList(rec) : null}
                              title={rec.Is_Parent ? "Edit Sub Menu Config" : "Disabled"}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                  )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {menuList.length > itemsPerPage ? (
            <CommonPagination
              pageList={menuList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          ) : null}
        </div>

        {newMenuModal && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" role="document">
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2-5">
                    <h5 className="modal-title">{selectedMenu?.Menu_Name ? "Edit Menu: " + selectedMenu?.Menu_Name : "New Menu"}</h5>
                    <button type="button" className="btn-close" onClick={handleNewMenuModalClose}></button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <div className="container mb-0" style={{ fontSize: "13px" }}>

                        <div className="row">

                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Menu</label>
                            <input type="text" className="form-control" placeholder="Enter Menu" {...register("Menu_Name", { required: "Menu is required" })} defaultValue={selectedMenu?.Menu_Name || ""} />
                            {errors.Menu_Name && <p className="text-danger required_error">{errors.Menu_Name.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Description</label>
                            <input type="text" className="form-control" placeholder="Enter Description" {...register("Description", { required: "Description is required" })} defaultValue={selectedMenu?.Description || ""} />
                            {errors.Description && <p className="text-danger required_error">{errors.Description.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">Url</label>
                            <input type="text" className="form-control" placeholder="Enter Url" {...register("Url", {
                              required: !isParent ? "URL is required when not a parent" : false
                            })}
                              defaultValue={selectedMenu?.Url || ""} />
                            {errors.Url && <p className="text-danger required_error">{errors.Url.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">
                              Icon
                              <span
                                className="ms-2 position-relative"
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setTooltipVisible(true)}
                                onMouseLeave={() => setTooltipVisible(false)}
                              >
                                <FaExclamationCircle
                                  size={14}
                                  color="#6c757d"
                                  onClick={() => window.open('https://react-icons.github.io/react-icons/icons/fa/', '_blank')}
                                />
                                {tooltipVisible && (
                                  <div
                                    className="position-absolute bg-dark text-white p-2 rounded"
                                    style={{
                                      zIndex: 1000,
                                      width: '200px',
                                      fontSize: '12px',
                                      top: '20px',
                                      left: '0'
                                    }}
                                  >
                                    Kindly choose icon from the
                                    <a
                                      href="https://react-icons.github.io/react-icons/icons/fa/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-info ms-1"
                                    >
                                      link
                                    </a>
                                    &nbsp;and type in the name
                                  </div>
                                )}
                              </span>
                            </label>
                            <input type="text" className="form-control" placeholder="Eg: FaCircle" {...register("Icon", { required: "Icon is required", validate: (value) => value in FaIcons || "Icon not found in react-icons/fa" })} defaultValue={selectedMenu?.Icon || ""} />
                            {errors.Icon && <p className="text-danger required_error">{errors.Icon.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">Sequence_No</label>
                            <input type="number" className="form-control" placeholder="Enter Sequence_No" {...register("Sequence_No")} defaultValue={selectedMenu?.Sequence_No || null} />
                          </div>
                          <div className="col-md-4 mb-2 d-flex align-items-center">
                            <div className="form-check mt-4">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                {...register("Is_Parent")}
                                defaultChecked={selectedMenu?.Is_Parent || false}
                              />
                              <label className="form-check-label fw-bold ms-2">Is Parent</label>
                            </div>
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">Role Access</label>
                            <MultiSelect
                              options={roleList}
                              selectedValues={roleList.filter(role => role.IsSelected)}
                              displayValue="Role_Name"
                              onSelect={(selectedList, selectedItem) => handleMappingInsert(selectedItem.Role_Id)}
                              onRemove={(selectedList, removedItem) => handleMappingDelete(removedItem.Role_Id)}
                              placeholder="Select Roles"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                        <button type="button" className="btn btn-danger" onClick={handleNewMenuModalClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{selectedMenu?.Menu_Id ? "Update" : "Save"}</button>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {editSubMenuModal && (
          <SubMenuComponent selectedMenuDet={selectedMenu} handleSubMenuModalClose={handleSubMenuModalClose} />
        )}

      </CommonContainer >
    </>
  );
}

export default MenuComponent